import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "react-fullscreen-loading";
import { useAuth } from "./AuthContext";
import { returnPathFromSearch } from "../utils/returnTo";

// Wraps public-only pages (signin, signup, password reset, etc.).
// If the user already has an active session, send them to their dashboard
// instead of showing the auth screen.
export const GuestRoute = ({ children }) => {
  const { status, userType } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <Loading loading={true} background="#fff" loaderColor="#883484" />;
  }
  if (status === "ready") {
    // Honours `?next=` (utils/returnTo) exactly as Signin does. It has to: on
    // React 17 the setSession() in Signin re-renders synchronously, so this
    // redirect fires before — and overrides — Signin's own navigate(). If the
    // two disagreed, the deep link from a renewal email would be lost.
    if (userType === "user") return <Navigate to={returnPathFromSearch(location.search) || "/user/dashboard"} replace />;
    if (userType === "reseller") return <Navigate to="/admin/resellerdashboard" replace />;
    // Covers every admin-portal role — admin, sales, and any role created later.
    if (userType === "admin") return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
};
